module.exports = __webpack_public_path__ + "static/media/AXP_BlueBoxLogo.1f8ac937.jpg";